export default {
	computed: {
		game(){
			if(!this.$store.state.game) return
			let game = { time: {min: '', sec: ''}, count: '', date: ""};
			game.date = new Date();
			game.time.min = Math.floor((this.$store.state.Time) / 60)-1;
			game.time.sec = Math.floor(this.$store.state.Time) - (game.time.min+1) * 60;
			game.count = this.$store.state.Time;
			game.time.min = game.time.min.toString();
			game.time.sec = game.time.sec.toString();
			return game;
		}
	},
	methods: {
		countDownTimer() {
	      if(!this.$store.state.game) return
	        if(this.$store.state.Time > 0) {
	          if(this.$store.state.Time < 156 && this.$store.state.Time > 132){
	            this.$router.push({name: 'TV4', params: {token: this.$route.params.Token, lang: this.$route.params.lang}});
	          }
	          if(this.$store.state.Time < 132 && this.$store.state.Time > 108){
	            this.$router.push({name: 'TV5', params: {token: this.$route.params.Token, lang: this.$route.params.lang}});
	          }
	          if(this.$store.state.Time < 108 && this.$store.state.Time > 84){
	            this.$router.push({name: 'TV6', params: {token: this.$route.params.Token, lang: this.$route.params.lang}});
	          }
	          if(this.$store.state.Time < 84 && this.$store.state.Time > 60){
	            this.$router.push({name: 'TV7', params: {token: this.$route.params.Token, lang: this.$route.params.lang}});
	          }
	          if(this.$store.state.Time < 60){
	            this.$router.push({name: 'countdown', params: {token: this.$route.params.Token, lang: this.$route.params.lang}});
	          }
	          /*if(!this.$options.timer){
	            this.$options.timer = setInterval(() => {
	                this.$store.state.Time = Math.floor((this.$store.state.game.Time - Date.now()) / 1000);
	            }, 1000)
	          }*/
	        }else{
	          this.$store.dispatch('apirequest', {token: 0, name: "game/"}).then((response) => {
	            this.$store.state.Time = Math.floor((this.$store.state.game.Time - Date.now()) / 1000);
	          });
	        }
	    },
		getteams(team){
	      if(!this.$store.state.teams) return
	      let result = this.$store.state.teams.filter(item => item.id == team);
	      return result[0].Abriviation
	    },
	    getimg(name){
	      if(name == null) return
	      if(!this.$store.state.teams) return
	      let result = this.$store.state.teams.filter(item => item.id == name);
	      if(result[0].Icon != ""){
	        return "https://champs-admin.info/gallery/" + result[0].Icon
	      }
	    },
	}
}